(function() {

    document.addEventListener(window.AseguraGoConstants.ASEGURAGO_CALLME_FORM_SUBMITED_EVENT, (event) => {
        document.querySelectorAll('.shared-popup-callme-wrapper').forEach(block => {            
            block.querySelector('.popup-callme-info').classList.add('hidden');
            block.querySelector('.shared-callme-success-wrapper').classList.remove('hidden');
        });
    });

})();